package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.ActiveCombat
import fr.manyverse.app.domain.model.CombatParticipant
import fr.manyverse.app.domain.model.CombatParticipantType
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.CombatRepository
import fr.manyverse.app.domain.repository.GameEventRepository

/**
 * Lance un combat : crée la ligne active avec ses participants ordonnés,
 * `activeIndex = 0` (le premier participant joue en premier), puis enregistre
 * un évènement COMBAT_STARTED dans l'historique de la table.
 */
class StartCombatUseCase(
    private val combatRepository: CombatRepository,
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        createdBy: String,
        participants: List<CombatParticipant>
    ): Result<ActiveCombat> {
        if (participants.isEmpty()) {
            return Result.failure(ValidationError("Le combat doit comporter au moins un participant"))
        }

        val combatResult = combatRepository.createCombat(tableId, createdBy, participants)
        val combat = combatResult.getOrElse { return Result.failure(it) }

        // Trace l'évènement dans l'historique (best-effort : un échec n'annule pas le combat).
        val targets = participants
            .filter { it.type == CombatParticipantType.CHARACTER }
            .mapNotNull { it.userId }
            .distinct()
        gameEventRepository.createEvent(
            tableId = tableId,
            type = EventType.COMBAT_STARTED,
            triggeredBy = createdBy,
            targetParticipants = targets,
            content = EventContent.CombatStarted(
                combatId = combat.id,
                participantCount = participants.size
            )
        )

        return Result.success(combat)
    }
}
